module.exports = __webpack_public_path__ + "static/aboutus-23ebe70ea0c37f17e75a75169da7f0bf.svg";